export const FETCH_COUNTRIES = '@reference/FETCH_COUNTRIES';
